import { makeStyles } from "@material-ui/styles";

export default makeStyles(theme => ({
    tableWidget: {
        overflowX: "auto",
        width: '100%',
        boxShadow: 'none !important'
    }
}));